import { render, staticRenderFns } from "./Bando29Fase7.vue?vue&type=template&id=c5d92264&scoped=true"
import script from "./Bando29Fase7.vue?vue&type=script&lang=js"
export * from "./Bando29Fase7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d92264",
  null
  
)

export default component.exports